import { Injectable } from '@angular/core';
import { ViewModel } from './view.model';

@Injectable()
export class UserProfileService {

  constructor(private viewModel: ViewModel) {
  }
}
